export const ANALYTICS_LINK = "https://dashboard.virtusize.jp/signin";
export const BANNER_SESSION_KEY = "show_banner";
